// extracted by mini-css-extract-plugin
export default {"root":"booking_note_actions-module___root___ae33f96e","loader":"booking_note_actions-module___loader___bd237625"};